<template>
  <!-- Conferma custom (coerente con la UI del progetto) mostrata quando si tenta
       di chiudere una modale con modifiche non salvate. Sostituisce i popup
       nativi (window.confirm). Teleport su body per stare sopra qualunque modale
       principale (custom o vue-final-modal). -->
  <teleport to="body">
    <div v-if="open" class="discard-backdrop" @click.self="$emit('stay')">
      <div class="villa-confirm" style="max-width: 420px">
        <h3 class="villa-confirm__title">Modifiche non salvate</h3>
        <p class="villa-confirm__text">
          Uscendo perderai le modifiche non salvate. Vuoi davvero uscire?
        </p>
        <div class="villa-confirm__actions">
          <button class="villa-btn villa-btn--ghost" @click="$emit('stay')">
            Resta
          </button>
          <button class="villa-btn villa-btn--danger" @click="$emit('discard')">
            Esci senza salvare
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: "DiscardChangesModal",
  props: {
    // Visibilità della conferma. Gestita dal componente ospite (mixin discardGuard).
    open: { type: Boolean, default: false },
  },
  // stay = resta nella modale principale; discard = esci scartando le modifiche.
  emits: ["stay", "discard"],
};
</script>

<!-- Riusa gli stili condivisi (villa-confirm, villa-btn); import unscoped e
     deduplicato da webpack, così il componente è autosufficiente ovunque. -->
<style src="@/css/GuestsPage.css" />
<style scoped>
.discard-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(8, 43, 87, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 16px;
}
</style>
